/* eslint-disable @typescript-eslint/no-shadow */
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const delegation = t.type({
  id: t.number,
  company: t.number,
  file: h.omittable(t.string),
  updated_at: t.string,
  created_at: t.string,
});

export type Delegation = t.TypeOf<typeof delegation>;
